<div class="p-6 lg:p-10 flex flex-col w-full h-full bg-body-background relative overflow-y-auto custom-scrollbar">

  <header class="flex flex-col gap-2 mb-8 shrink-0">
    <h2 class="text-2xl lg:text-3xl font-extrabold text-heading tracking-tight">
      <i class="fas fa-history text-primary mr-2"></i> {{ config.texts.title }}
    </h2>
  </header>

  @if (events().length === 0) {
  <div
       class="flex flex-col items-center justify-center p-12 bg-component-inner border border-primary-border rounded-xl shadow-sm text-secondary-text w-full max-w-3xl mx-auto flex-1 max-h-[400px]">
    <div
         class="w-16 h-16 bg-alt-background rounded-full flex items-center justify-center border border-secondary-border mb-4">
      <i class="fad fa-clock text-3xl"></i>
    </div>
    <p class="font-medium text-lg">{{ config.texts.noEvents }}</p>
  </div>
  } @else {
  <div class="max-w-4xl w-full">
    <nz-timeline>
      @for (evt of events(); track evt.id) {
      <nz-timeline-item [nzDot]="customDot">

        <ng-template #customDot>
          <div class="w-10 h-10 rounded-full flex items-center justify-center shadow-sm border -ml-1.5"
               [ngClass]="getOperationTheme(evt.operationType).bgClass">
            <i
               [class]="'fas text-lg ' + getOperationTheme(evt.operationType).icon + ' ' + getOperationTheme(evt.operationType).colorClass"></i>
          </div>
        </ng-template>

        <div class="pl-4 pb-6 w-full">
          <rapider-timeline-node-card [event]="evt"
                                      [data]="fetchedDataMap()[evt.id]"
                                      [isLoading]="loadingMap()[evt.id] || false">
          </rapider-timeline-node-card>
        </div>

      </nz-timeline-item>
      }
    </nz-timeline>
  </div>
  }
</div>